import React, { createContext, useContext, useState, useEffect, ReactNode } from "react";
import { getConfig, AppConfig } from "./config";
import Loader from "components/Loader";

interface ConfigContextType {
  config: AppConfig | null;
}

const ConfigContext = createContext<ConfigContextType>({ config: null });

export const ConfigProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [config, setConfig] = useState<AppConfig | null>(null);

  useEffect(() => {
    getConfig().then(setConfig);
  }, []);

  return (
    <ConfigContext.Provider value={{ config }}>
      {config ? children : <div><Loader/></div>}
    </ConfigContext.Provider>
  );
};

export const useConfig = () => useContext(ConfigContext);
